import { render } from "./en.vue?vue&type=template&id=36c47646&ts=true"
import script from "./en.vue?vue&type=script&lang=ts"
export * from "./en.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__